import {emojis, type EmojiItem} from "@tiptap/extension-emoji";

export const EMOJI_PAGE_SIZE = 100;

// Some catalogue entries lack the variation selector that makes them render as colour emoji.
const withEmojiPresentation = (item: EmojiItem): EmojiItem => {
    const sequence = item.fallbackImage?.match(/\/([0-9a-f-]+)\.png(?:[?#].*)?$/i)?.[1];
    if (!sequence?.toLowerCase().split('-').includes('fe0f')) return item;

    const codePoints = sequence.split('-').map(codePoint => Number.parseInt(codePoint, 16));
    if (codePoints.some(Number.isNaN)) return item;

    return {...item, emoji: String.fromCodePoint(...codePoints)};
};

export const EMOJIS = emojis.filter(item => (
    Boolean(item.emoji)
    && !item.name.startsWith('regional_indicator_')
    && item.group !== 'components'
)).map(withEmojiPresentation);

export const emojiLabel = (item: EmojiItem) => {
    const label = item.name.replace(/[_-]+/g, ' ');
    return label.charAt(0).toUpperCase() + label.slice(1);
};

export const emojiGroupTranslationKey = (group?: string) => {
    if (!group) return 'Smileys & emotion';
    return group.charAt(0).toUpperCase() + group.slice(1);
};

export const findEmojis = (catalog: EmojiItem[], query: string) => {
    const needle = query.trim().toLowerCase();
    return needle
        ? catalog.filter(item => [item.name, ...item.shortcodes, ...item.tags, item.group ?? '']
            .some(candidate => candidate.toLowerCase().includes(needle)))
        : catalog;
};
